import React from 'react';
import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Navbar, Image } from "react-bootstrap";
import RightHeader from "./headerBrandRight"
import BottomHeaderRight from "./bottomHeader/bottomHeaderRight/bottomHeaderRight";
import BottomHeaderLeft from "./bottomHeader/bottomHeaderLeft/bottomHeaderLeft";
import Logo from '../../assests/images/gnp_logo.svg';
import {
  Fixheader,
  FixsubHeader,

  FixdnavBar,
  TopnavBar,
} from "./headerStyle";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const [isFixed, setIsFixed] = useState<boolean>(false);
  const [showNavbar, setShowNavbar] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsFixed(scrollTop > 0);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <Fixheader>
      <Navbar expand="lg" className="bg-color-new flex-col" >
        <Container className="header-container">
          <TopnavBar>
            <Navbar.Brand onClick={() => navigate("/")}><Image src={Logo} alt="logo" width="316px" height="24px" /></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setShowNavbar(!showNavbar)} />
            <RightHeader />
          </TopnavBar>
        </Container>
        <FixsubHeader className={`fixed-navbar ${isFixed ? 'fixed' : ''}`}>

          <Container className="header-container">
            <FixdnavBar className="bottom-header-section">
              <BottomHeaderLeft showNavbar={showNavbar} setShowNavbar={setShowNavbar} />
              <BottomHeaderRight />
            </FixdnavBar>
          </Container>
        </FixsubHeader>
      </Navbar>
    </Fixheader>
  );
};
export default Header;